import React from 'react';
import { Card } from 'react-bootstrap';
import img_main from '../../assets/images/img_main_01.png';

import moment from 'moment';
import { GetDayInfo, GetMonthInfo } from './http';

const days = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];

class FormsElements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            minwon: {
                allCount: 0,
                completeCount: 0,
                cancelCount: 0,
                overCount: 0,
            },
            bundong: {
                allCount: 0,
                completeCount: 0,
                cancelCount: 0,
                overCount: 0,
            },
            stats: {
                allCount: 0,
                completeCount: 0,
                price: 0,
            },
            list: [
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
                {
                    date: '',
                    price: 0,
                },
            ],
        };

        GetDayInfo(this, res => {
            this.setState({ minwon: res.minwon, bundong: res.bundong, stats: res.stats });
        });

        GetMonthInfo(this, res => {
            this.setState({ list: res });
        });
    }

    render() {
        const { minwon, bundong, stats, list } = this.state;

        return (
            <div>
                {/* 메인 */}
                <div className="main_top_imgs">
                    <img src={img_main} alt="메인 이미지" />
                </div>

                <div className="sky_tit">
                    <h4>오늘 현재 ({moment().format('MM월 DD일 ') + days[moment().day()]})</h4>
                </div>

                <div className="div_3">
                    <div className="col_1">
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">민원24 배차현황</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <colgroup>
                                            <col width="25%" />
                                            <col width="25%" />
                                            <col width="25%" />
                                            <col width="25%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>민원24 배차 접수</th>
                                                <th>민원24 배차완료</th>
                                                <th>초과검사</th>
                                                <th>미배차</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="bgGray">{minwon.allCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{minwon.completeCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{minwon.overCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{minwon.cancelCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col_1">
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">한국분동 배차현황</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <colgroup>
                                            <col width="25%" />
                                            <col width="25%" />
                                            <col width="25%" />
                                            <col width="25%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>본사배차</th>
                                                <th>본사배차 완료</th>
                                                <th>초과검사</th>
                                                <th>본사미배차</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="bgGray">{bundong.allCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{bundong.completeCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{bundong.overCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{bundong.cancelCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col_1">
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">운반통계</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <colgroup>
                                            <col width="33.33%" />
                                            <col width="33.33%" />
                                            <col width="33.33%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>접수건수</th>
                                                <th>완료건수</th>
                                                <th>당월마감 총계</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="bgGray">{stats.allCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{stats.completeCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                <td>{stats.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>

                <div className="gab30"></div>

                <Card>
                    <Card.Header>
                        <Card.Title as="h5">일일 매출 현황</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="table_board_box">
                            <table className="tbl_board">
                                <thead>
                                    <tr>
                                        <th>날짜</th>
                                        <th>{moment(list[0].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[1].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[2].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[3].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[4].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[5].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[6].date).format('MM월 DD일')}</th>
                                        <th>{moment(list[7].date).format('MM월 DD일')}(오늘)</th>
                                        <th>최근 7일 합계</th>
                                        <th>최근 30일 합계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="bgGray">합계</td>
                                        <td>{list[0].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[1].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[2].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[3].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[4].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[5].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[6].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td className="bgGray">{list[7].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[8].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                        <td>{list[9].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Card.Body>
                </Card>

                <div className="gab40"></div>

                {/* 메인 끝 */}
            </div>
        );
    }
}

export default FormsElements;
